import React, { useState } from "react";
import { HORIZONTAL_RULE_COLOR } from "../../tokens";
import { useSettings } from "../../utils/settings";

export const RadioSetting: React.FC<{
    settingId: string;
    options: { id: string; name: string }[];
}> = (props) => {
    const { settingId, options } = props;

    const {
        settings,
        setSetting,
    }: { settings: any; setSetting: any } = useSettings();

    const selectedId = settings[settingId];

    const [hoveredId, setHoveredId] = useState<string | undefined>(undefined);

    return (
        <div
            style={{
                paddingBottom: 4,
                borderBottom: `0.5px solid ${HORIZONTAL_RULE_COLOR}`,
            }}
        >
            {options.map(({ id, name }) => {
                return (
                    <div
                        style={{
                            borderRadius: 4,
                            padding: 4,
                            paddingLeft: 12,
                            paddingRight: 12,
                            cursor: "pointer",
                            backgroundColor:
                                selectedId === id
                                    ? "#e0e0e0"
                                    : hoveredId === id
                                    ? "#f0f0f0"
                                    : "transparent",
                        }}
                        onClick={() => {
                            setSetting(settingId, id);
                        }}
                        onMouseEnter={() => setHoveredId(id)}
                        onMouseLeave={() => setHoveredId(undefined)}
                    >
                        {name}
                    </div>
                );
            })}
        </div>
    );
};
